module.exports = "/_next/static/images/success-plus-graph-7c8c49cf8be0b911c4f9e406a005d2f5.png";